/**
 * @author Arul Vivek
 */
 import service from '../Common/'
 import constants from '../../../settings/shared/constants'


 
  function AnalyzeProject(param) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.analyze,
            method: 'POST',
            headers: headers,
            data:  param
        }); 
 }

 function NewProject(param) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.newProject,
            method: 'POST',
            headers: headers,
            data:  param
        }); 
 }

 function GetProject(pageNumber, pageSize) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.getallProject + "?page=" + pageNumber + "&size=" + pageSize,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function GetProjectById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.getProjectbyId+'/'+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function Runproject(runData,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.run+"/"+id,
            method: 'POST',
            headers: headers,
            data:  runData
        });
 }

  function CompareProject(runIds) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.compareTable,
            method: 'POST',
            headers: headers,
            data:  runIds
        });
 }

  function Updateproject(updateData,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.update+"/"+id,
            method: 'PUT',
            headers: headers,
            data:  updateData
        });
 }

   function Deleteproject(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.delete+'/'+id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
 }

  function GetRunsByProject(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.getrunsbyId+'/'+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function GetRecentProject(pageNumber, pageSize) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.getRecentProject + "?page=" + pageNumber + "&size=" + pageSize,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function GetTags(from,key) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.getTagsProject+'?filterType='+from+'&key='+key,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function GetAutoCompleteResult(from,key) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.getAutocomplete+'?filterType='+from+'&key='+key,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function FavoriteProject(favid,favbool) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.addFavProject+'/'+favid+'?favoriteItem='+favbool,
            method: 'POST',
            headers: headers,
            data:  ''
        });
 }
 function GetFavoriteProject(pageNumber, pageSize) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.getFavProject + "?page=" + pageNumber + "&size=" + pageSize,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function CompareotherProject(projectData,key,page,limit) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.compareProject+"?key="+key+"&page="+page+"&limit="+limit,
            method: 'POST',
            headers: headers,
            data: projectData
        });
 }


 function CompareDownload(compareData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.project.compareDownload,
            method: 'POST',
            headers: headers,
            data:  compareData
        });
 }

//To export run function
const ProjectService = {
    AnalyzeProject,NewProject,GetProject,GetProjectById,Updateproject,Deleteproject,Runproject,GetRunsByProject,CompareProject,GetRecentProject,GetTags,FavoriteProject,GetFavoriteProject,
    GetAutoCompleteResult,CompareotherProject,CompareDownload
}
export default ProjectService;
